import {types} from './types';

const initialState = {
    list: null,
    cashiers: {
        data: [],
        countPage: 0
    },
}

export function balanceReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_CATEGORIES_LIST:
            return { ...state, list: action.payload};
        case types.SET_CASHIERS_PROFILE:
            return { ...state, cashiers: action.payload}
        default:
            return state
    }
}